module.exports = require("plugin-mantine-resources/shared/hooks/useThemeListener");